import { memo, useCallback } from 'react';
import { formatAmount } from '@betty/toolkit/utils';
import { Text, PressableOverlay } from '@betty/moonlight';
import { AmountProps } from './Amount.types';
import AmountContainer from '../AmountContainer/AmountContainer';

function Amount({ amount, disabled, selected, onPress }: AmountProps) {
  const handlePress = useCallback(() => {
    onPress(amount);
  }, [amount, onPress]);

  return (
    <AmountContainer selected={selected} opacity={disabled ? 0.5 : undefined}>
      <Text
        variant="h6"
        {...(selected
          ? { color: 'accentSurfacePrimary' }
          : { gradient: 'darkSurfaceAccent' })}
      >
        {formatAmount(amount)}
      </Text>
      <PressableOverlay onPress={disabled ? undefined : handlePress} />
    </AmountContainer>
  );
}

export default memo(Amount);
